<template>
    <!-- v-bind:class="['footercontain','display_flex','align-items_center', is_class_bottom?'fixbottom':'']" -->
    <div v-bind:class="['footercontain', is_class_bottom?'fixbottom':'']"> 
        <div class="footwidth display_flex justify-content_flex-justify align-items_flex-start" style="padding-top:50px;">
            <!-- <div class="limitwidth"> -->
                <div class="inline-block">
                <div class="inline-block" style="vertical-align:top;">
                    <div class="slider-index" v-for="(item,index) in menu">
                        <router-link target="_blank" :to="{path:item.path}">{{item.name}}</router-link>
                    </div>
                </div>
                <div class="inline-block copyright">
                    <div>Copyright 2016-{{currentyear}} fishqc.com All rights reserved.</div>
                    <div class="display_flex justify-content_flex-justify" style="padding-top:16px;width:365px;">
                        <div class="vertical-middle"><a style="color:#A8A8AD" target="_blank" href="//beian.miit.gov.cn">粤ICP备18074060号</a></div>
                        <div>
                            <a style="color:#A8A8AD" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010402001561">
                            <img src="http://p1.fishqc.net/gongan-beian.png" style="width:18px;margin-right: 5px;vertical-align: middle;">粤公网安备 44010402001561号</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="inline-block focusclass">
                <span class="focustxt">{{$t('common.aboutxiaoyu')}}</span>
                <a class="icon-footer qrcover">
                    <img src="https://p1.fishqc.net/FnAYLa5zU4FrjyHk0r7N_re6lUOe" class="vertical-middle weixin " width="26px" height="26px">
                    <div class="qrimg">
                        <img src="https://p1.fishqc.net/FpRCj8D-jfZABkh3Mi9yQDrYkuYv" width="180px" height="180px">
                    </div>
                </a>
                <a href="http://weibo.com/u/6135537891" class="icon-footer" target="_blank">
                    <img src="https://p1.fishqc.net/FpWx17hH_XID-8IPybffFuDyyc5A" class="vertical-middle" width="26px" height="26px">
                </a>
                <a href="https://www.facebook.com/Vitargent/" class="icon-footer" target="_blank">
                    <img src="https://p1.fishqc.net/FmH98CCouq0rh157jcM-QtX-Tluy" class="vertical-middle" width="24px" height="24px">
                </a>
                <a href="https://www.linkedin.com/m/company/2086233" class="icon-footer" target="_blank">
                    <img src="https://p1.fishqc.net/Fic7LLjWEKXxcZf7AmAY137NDvPM" class="vertical-middle" width="22px" height="22px">
                </a>
            </div>
            <!-- </div> -->
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.inline-block {
    display: inline-block;
}

.vertical-middle {
    vertical-align: middle;
}

.footercontain {
    height: 120px;
    // line-height: 120px;
    background: #fff;
    width: 100%;
    border-top: 1px solid #F4F4F5;

    &.fixbottom {
        width: 100%;
        position: fixed;
        bottom: 0;
        z-index: 3
    }

    .footwidth {
        width: $pageWidth;
        margin: 0 auto;
        text-align: left;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
        color: #A8A8AD;
        
    }
    .limitwidth{
        width: $pageWidth;
        margin:0 auto;
    }
    .slider-index {
        display: inline-block;

        margin: 0 16px;
        cursor: pointer;

        a {
            text-decoration: none;
            color: #A8A8AD;
        }

        &:nth-of-type(1) {
            margin-left: 0;
        }

        &:nth-of-type(4) {
            // margin-right:0;
        }

    }

    .copyright {
        padding-left: 100px;
    }

    .focusclass {

        // float:right;
        .focustxt {
            display: inline-block;
            position: relative;
            vertical-align: middle;

            &:after {
                content: '';
                position: absolute;
                width: 2px;
                height: 22px;
                right: -30px;
                top: -4px;
                background-color: #D5D5D7;
            }

        }

        .icon-footer {
            margin-left: 36px;

            &:nth-of-type(1) {
                margin-left: 86px;
            }
        }
    }
}

.weixin {}

.qrcover {
    position: relative;
    cursor: pointer;

    &:hover {
        .qrimg {
            display: block;
        }
    }

    .qrimg {
        width: 200px;
        height: 200px;
        padding: 10px;
        background: #fff;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
        box-sizing: border-box;
        position: absolute;
        left: -90px;
        top: -220px;
        z-index: 2;
        border-radius: 8px;
        display: none
    }
}
</style>
<script>
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'pfooter',
    components: {},
    mixins: [myMixin],
    data() {
        return {
            menu: [{
                    name: this.$t('common.footer.about'),
                    path: '/about?position=aboutfishqc'
                },
                {
                    name: this.$t('common.footer.contact'),
                    path: '/about?position=contact'
                },
                {
                    name: this.$t('common.footer.technology'),
                    path: '/about?position=technology'
                },
                // {
                //     name: 'F&Q',
                //     path: ''
                // }
            ],
            currentyear:''

        }
    },
    methods: {
        choosetab(item) {
            window.open(item.path, '_blank')
            // this.gorouter(item.path)
        },
    },
    mounted() {
            const start = new Date(); 
            this.currentyear = start.getFullYear();
        },
    computed: {
        is_class_bottom() {
            return this.$store.state.is_class_bottom
        }
    }
}





</script>